function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, React.createElement("path", {
  d: "M23.25,4.497 L0.75,4.497"
}), React.createElement("polyline", {
  points: "4.5 8.247 .75 4.497 4.5 .747"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "icon",
    viewBox: "0 0 24 9",
    style: {
      "height": "1em",
      "width": "2.66667em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/back-arrow.278537b8.svg";
export { SvgComponent as ReactComponent };